import { useQuery } from '@tanstack/react-query';

import { useProductCenterApi } from 'api';
import { userVisibilitySettingsQuery } from 'api/queries/UserSettingsQueries';
import { LoadingWrapper } from 'library/components/controls/loaders/LoadingWrapper';

import SearchProductPage from './SearchProductPage';

const SearchProductPageLoader = (): React.JSX.Element => {
	const { api } = useProductCenterApi();

	const { data, isLoading } = useQuery({
		...userVisibilitySettingsQuery(api, 'SearchProductGrid'),
		throwOnError: false,
		gcTime: 0,
	});

	return (
		<LoadingWrapper loading={isLoading}>
			<SearchProductPage
				initialColumnVisibilityModel={data?.data?.settings}
			/>
		</LoadingWrapper>
	);
};

export default SearchProductPageLoader;
